module.exports = __webpack_public_path__ + "static/media/10_r_hrusevka_83.75_55.65.b98a190d.png";